import { useDisclosure } from "@mantine/hooks";
import { TblDMBarcodeStatus } from "../../../model/BarcodeStatus";
import { useForm } from "@mantine/form";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  TextInput,
} from "@mantine/core";
import { handleKeyDown } from "../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../const/variables";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

type CreateItemViewProps = {
  onClose: any;
};
export const CreateItemView = ({ onClose }: CreateItemViewProps) => {
  const entity: Partial<TblDMBarcodeStatus> = {
    id: "0",
    maTtmv: "",
    tenTtmv: "",
    ksd: false,
    isMacDinhNhapMua: false,
    maCty: "",
  };
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const form = useForm<Partial<TblDMBarcodeStatus>>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      maTtmv: (value: string | null | undefined) => {
        if (!value) return "Mã trạng thái mã vạch không được bỏ trống";
      },
      tenTtmv: (value: string | null | undefined) => {
        if (!value) return "Tên trạng thái mã vạch không được bỏ trống";
      },
      maCty: (value: string | null | undefined) => {
        if (!value) return "Mã công ty không được bỏ trống";
      },
    },
  });
  const handleCreate = async (dataSubmit: Partial<TblDMBarcodeStatus>) => {
    open();
    const callApi = await repositoryMdm.post<
      MessageResponse<TblDMBarcodeStatus>
    >("/api/v1/BarcodeStatus/create", dataSubmit);
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
      NotificationExtension.Success("Thêm thành công !");
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
  };
  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: Partial<TblDMBarcodeStatus>) => {
          // console.log(e);
          handleCreate(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={12}>
            <TextInput
              label={"Mã trạng thái mã vạch"}
              placeholder={"Nhập mã trạng thái mã vạch"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("maTtmv")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Tên trạng thái mã vạch"}
              placeholder={"Nhập tên mã trạng thái mã vạch"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("tenTtmv")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <Checkbox label={"Không sử dụng"} {...form.getInputProps("ksd")} />
          </Grid.Col>
          <Grid.Col span={6}>
            <Checkbox
              label={"Mặc định nhập/mua"}
              {...form.getInputProps("isMacDinhNhapMua")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Mã công ty"}
              placeholder={"Nhập mã công ty"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("maCty")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};
